var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo:
            "Editar Configuración Base: " + _vm.alertaBaseSeleccionada.nombre,
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          entidad: "Configuración Base",
          nombreEntidad: _vm.alertaBaseSeleccionada
            ? _vm.alertaBaseSeleccionada.nombre
            : "",
          pasoActivoIndex: _vm.pasoActivoIndex
        },
        on: { cerrar: _vm.handleCerrar, guardar: _vm.handleGuardar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("SeleccionarCodigosForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.seleccionarCodigos.step,
                expression: "pasoActivoIndex === pasos.seleccionarCodigos.step"
              }
            ],
            attrs: {
              alertaBaseSeleccionada: _vm.alertaBaseSeleccionada,
              esEditar: true
            },
            on: {
              change: _vm.handleFormChange,
              setCodeAct: _vm.handleCodeAct,
              setCodeActExt: _vm.handleCodeActExt
            }
          }),
          _vm.pasoActivoIndex === _vm.pasos.agregarCampos.step
            ? _c("AgregarCamposGrid", {
                attrs: {
                  camposDinamicos: _vm.camposDinamicos,
                  modoEditar: true
                },
                on: { changeCampos: _vm.handleCamposChange }
              })
            : _vm._e(),
          _vm.pasoActivoIndex === _vm.pasos.scriptValidacionExtendida.step
            ? _c("ValidacionExtendidaForm", {
                attrs: { scriptActividadExt: _vm.scriptActividadExt },
                on: { setScript: _vm.handleScriptValidacionExtendida }
              })
            : _vm._e(),
          _vm.pasoActivoIndex === _vm.pasos.htmlTemplateAccion.step
            ? _c("HtmlTemplateForm", {
                attrs: { htmlTemplate: _vm.htmlTemplate, mensaje: _vm.mensaje },
                on: {
                  setHtml: _vm.handleTemplate,
                  setMensaje: _vm.handleMensaje
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }